import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { PointRaceDto, RaceAdminSummaryDto } from '@aoe/client';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectRaceAdminList } from 'src/app/core/store/admin/race-admin/raceAdmin.selector';

@Component({
  selector: 'aoe-race-linked',
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule, MatIconButton, MatIconModule, CommonModule, ReactiveFormsModule],
  templateUrl: './race-linked.component.html',
  styleUrl: './race-linked.component.scss',
})
export class RaceLinkedComponent implements OnInit {

  @Input()
  racePointForm!: FormGroup

  private fb = inject(FormBuilder);
  private store = inject(Store);

  races$!: Observable<RaceAdminSummaryDto[]>;

  // racePointForm!: FormGroup;

  ngOnInit(): void {
    this.races$ = this.store.select(selectRaceAdminList);
  }
  get attachedRaces(): FormArray<FormGroup> {
    return this.racePointForm?.get('attachedRaces') as FormArray<FormGroup>;
  }


  /** Création d'un sous-FormGroup pour une liaison Race <-> Point */
  createRacePointGroup(data?: Partial<PointRaceDto>): FormGroup {
    return this.fb.group({
      raceId: new FormControl<string>(data?.raceId ?? '', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      nbPassage: new FormControl<number>(data?.nbPassage ?? 1, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(1)],
      }),
      distanceFromStart: new FormControl<number | null>(data?.distance ?? null, {
        validators: [Validators.required, Validators.min(0)],
      }),
      elevation: new FormControl<number | null>(data?.elevation?.elevation ?? null, {
        validators: [Validators.required],
      }),
      elevationFromStart: new FormControl<number | null>(data?.elevation?.fromStart ?? null, {
        validators: [Validators.required, Validators.min(0)],
      }),
      openingDate: new FormControl<string | null>(data?.date?.start ?? null),
      closingDate: new FormControl<string | null>(data?.date?.end ?? null),
    });
  }

  /** Ajouter un nouveau bloc de liaison course */
  addRaceLink(data?: Partial<PointRaceDto>): void {
    this.attachedRaces.push(this.createRacePointGroup(data));
  }

  /** Supprimer un bloc de liaison course par son index */
  removeRaceLink(index: number): void {
    this.attachedRaces.removeAt(index);
  }

}
